type YmArgs = [string, ...unknown[]];

let counterId = 0;
const queue: YmArgs[] = [];

export function initYm(id: number): void {
  counterId = id;
}

export function getCounterId(): number {
  return counterId;
}

export function callYm(method: string, ...args: unknown[]): void {
  if (counterId === 0) return;
  const ym = (globalThis as { ym?: (...a: unknown[]) => void }).ym;
  if (typeof ym === "function") {
    ym(counterId, method, ...args);
  } else {
    queue.push([method, ...args]);
  }
}

export function flushQueue(): void {
  if (counterId === 0) return;
  const ym = (globalThis as { ym?: (...a: unknown[]) => void }).ym;
  if (typeof ym !== "function") return;
  while (queue.length > 0) {
    const entry = queue.shift();
    if (entry === undefined) break;
    ym(counterId, ...entry);
  }
}

/** Test-only: reset module state */
export function resetForTests(): void {
  counterId = 0;
  queue.length = 0;
}
